/* global Waypoint */

import $ from 'jquery';
import svgCircleLoader from './svgCircleLoader';
import config from './config';

const $window = $(window);
const waypoints = [];
let current = 0;
/* eslint-disable no-unused-vars */
let $waypointsThing = $();
/* eslint-enable no-unused-vars */
let $waypoints;
let $arrowUp;
let $arrowDown;
let $text;
let circle = null;
const standardOffset = 70;
const scrollSpeed = 1000;
const shift = 5;
const easing = 'easeOutCubic';
let isScrolling = false;

function showArrow($el) {
  $el.removeClass('waypoints__arrow--hidden');
}

function hideArrow($el) {
  $el.addClass('waypoints__arrow--hidden');
}

function arrowsVisibility(i) {
  if (i) {
    current = i;
  }

  if (current === 0) {
    // pierwszy
    hideArrow($arrowUp);
    showArrow($arrowDown);
  } else if (current === waypoints.length - 1) {
    // ostatni
    showArrow($arrowUp);
    hideArrow($arrowDown);
  } else {
    // środek
    showArrow($arrowUp);
    showArrow($arrowDown);
  }
}

function getOffset(i) {
  let val = standardOffset;

  if (i === 0) {
    val = -100;
  } else if (
    i === $waypoints.length - 1
    && $waypoints.last().outerHeight() + standardOffset < $window.height()
  ) {
    val = $window.height() - $waypoints.last().outerHeight() + 100;
  }

  return val;
}

function getPadding(i, shiftValue) {
  let val = standardOffset;

  if (i === 0) {
    val = 0;
  } else if (
    i === $waypoints.length - 1
    && $waypoints.last().outerHeight() + standardOffset < $window.height()
  ) {
    val = $window.height() - $waypoints.last().outerHeight();
  }

  return val + shiftValue;
}

function init() {
  $waypointsThing = $('.waypoints');
  $waypoints = $('.waypoint');
  $arrowUp = $('.waypoints__arrow-up');
  $arrowDown = $('.waypoints__arrow-down');
  $text = $('.waypoints__text');

  arrowsVisibility();
  $waypoints.each(function (i) {
    const waipoint = new Waypoint({
      element: this,
      offset: getOffset(i),
      handler() {
        current = i;
        circle.update('main', 'percent', current / (waypoints.length - 1) * 100);
        arrowsVisibility();
      },
    });

    waypoints.push(waipoint);
  });

  circle = svgCircleLoader(document.getElementsByClassName('waypoints__circle')[0], {
    width: 70,
    height: 70,
    cx: 35,
    cy: 35,
    r: 30,
    strokeWidth: 3,
    strokeWidthBg: 3,
    stroke: '#004c9a',
    strokeBg: '#ccc',
    cssClass: 'waypoints__circle__main',
    cssClassBg: 'waypoints__circle__bg',
  });

  $arrowUp.on('click', () => {
    const prevIdx = current - 1;

    $(waypoints[prevIdx].element).animatescroll({
      scrollSpeed,
      easing,
      padding: getPadding(prevIdx, shift),
    });
  });

  $arrowDown.on('click', () => {
    const nextIdx = current + 1;

    $(waypoints[nextIdx].element).animatescroll({
      scrollSpeed,
      easing,
      padding: getPadding(nextIdx, -shift),
    });
  });
}

function scroll() {
  if ($window.scrollTop() > 10) {
    if ($text) {
      $text.addClass('waypoints__text--hidden');
    }
  } else if ($text) {
    $text.removeClass('waypoints__text--hidden');
  }
}

function mousewheel(evt) {
  const eventDataRest = evt.originalEvent.wheelDelta;
  const eventDataFirefix = evt.originalEvent.detail;
  let scrollMe;

  if (eventDataRest) {
    scrollMe = eventDataRest > 0 ? -1 : 1;
  } else {
    scrollMe = eventDataFirefix > 0 ? 1 : -1;
  }

  if (typeof scrollMe !== 'undefined' && !isScrolling && waypoints[current + scrollMe]) {
    const idx = current + scrollMe;

    $(waypoints[idx].element).animatescroll({
      scrollSpeed,
      easing,
      padding: getPadding(idx, shift * -scrollMe),
      onScrollStart() {
        isScrolling = true;
      },
      onScrollEnd() {
        isScrolling = false;
      },
    }, 500);
  }
}

function switchMouseWheel(switchOn) {
  if (switchOn) {
    config.$el.window.on('mousewheel DOMMouseScroll', e => {
      if (!document.body.classList.contains('__pko-cookie-mobile-blocked__')) {
        // e.preventDefault(); - TJ - nie wiem czy to tutaj powinno być, zakomentowane bo powoduje błąd na chrome
        this.mousewheel(e);
      }
    });
  } else {
    config.$el.window.off('mousewheel DOMMouseScroll');
  }
}

export default {
  init,
  scroll,
  mousewheel,
  switchMouseWheel,
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/waypoints.js